import React from 'react';

// Components
import { FormattedMessageV2 } from '@/views/components/i18n';
import { PrimaryLink } from '@/views/components/buttons';
import { Tooltip } from '@/views/components/tooltips';

// Utils
import { formatMessage } from '@/utils/i18n';

const MAX_CUSTOM_SCENARIOS = 5;

interface HistoricalScenariosFilterDropdownItemsProps {
  maxCustomScenarios?: number;
  onCreateScenario: () => void;
  totalCustomScenarios: number;
}

const HistoricalScenariosFilterCreateCustomScenario: React.FC<HistoricalScenariosFilterDropdownItemsProps> = ({
  maxCustomScenarios = MAX_CUSTOM_SCENARIOS,
  onCreateScenario,
  totalCustomScenarios,
}) => (
  <div className="create-custom-scenario">
    <Tooltip
      className="custom-tooltip-v2"
      disabled={totalCustomScenarios < maxCustomScenarios}
      place="bottom"
      effect="solid"
      message={formatMessage('Comparison.HistoricalScenarios.MaximumCustomScenariosAllowed', { count: maxCustomScenarios })}
    >
      <PrimaryLink className="no-margin" onClick={onCreateScenario} disabled={totalCustomScenarios >= maxCustomScenarios}>
        <i className="icon-ds-add" />
        <FormattedMessageV2 toLocalize="Comparison.HistoricalScenarios.CreateCustomScenario" />
      </PrimaryLink>
    </Tooltip>
  </div>
);

export default HistoricalScenariosFilterCreateCustomScenario;
